import { render, staticRenderFns } from "./sale_counter.vue?vue&type=template&id=cf8e305e&"
import script from "./sale_counter.vue?vue&type=script&lang=ts&"
export * from "./sale_counter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports